module.exports = __webpack_public_path__ + "img/Bitfluent_Mockups.9058e899.png";